import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { IChecklistV2FilterAvailableItems, IChecklistV2ReportParameter } from './fi-checklist2-report';
import { FiChecklist2ReportHelperService } from '../services/fi-checklist2-report-helper.service';
import { FiChecklist2ReportData } from './fi-checklist2-report-data';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';
import { FiChecklist2ReportDataService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-data.service';

@Directive()
export abstract class FiReportWidgetDetailsBaseDirective {
    @Input() reportData: FiChecklist2ReportData;
    @Input() reportParam: IChecklistV2ReportParameter;
    @Output() reportParamChange = new EventEmitter<IChecklistV2ReportParameter>();
    @Input() reportParametersCount: number;
    @Input() isFilterExpanded: boolean;
    @Input() isSearchShown: boolean = true;

    get availableItems(): IChecklistV2FilterAvailableItems {
        return this.reportData.availableItems;
    }

    constructor(
        protected fiChecklist2ReportHelperService: FiChecklist2ReportHelperService,
        protected fiChecklist2ReportDialogsService: FiChecklist2ReportDialogsService,
        protected fiChecklist2ReportDataService: FiChecklist2ReportDataService,
    ) {}

    getWidgetDescription() {
        return this.fiChecklist2ReportHelperService.getWidgetDescription(this.reportParam);
    }
}
